import { library } from '@fortawesome/fontawesome-svg-core'

import { faFileInvoice } from '@fortawesome/pro-solid-svg-icons/faFileInvoice'
import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons/faFileInvoiceDollar'
import { faFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt'
import { faFileExclamation } from '@fortawesome/pro-solid-svg-icons/faFileExclamation'
import { faFile } from '@fortawesome/pro-solid-svg-icons/faFile'
import { faFileUser } from '@fortawesome/pro-solid-svg-icons/faFileUser'
import { faFileSignature } from '@fortawesome/pro-solid-svg-icons/faFileSignature'
import { faFileContract } from '@fortawesome/pro-solid-svg-icons/faFileContract'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { faUserCircle } from '@fortawesome/pro-solid-svg-icons/faUserCircle'
import { faTools } from '@fortawesome/pro-solid-svg-icons/faTools'
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp'
import { faThumbsDown } from '@fortawesome/pro-solid-svg-icons/faThumbsDown'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faStarExclamation } from '@fortawesome/pro-solid-svg-icons/faStarExclamation'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faExclamationSquare } from '@fortawesome/pro-solid-svg-icons/faExclamationSquare'
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faCheckDouble } from '@fortawesome/pro-solid-svg-icons/faCheckDouble'
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare'
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt'
import { faCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar'
import { faCalculator } from '@fortawesome/pro-solid-svg-icons/faCalculator'
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons/faBadgeCheck'
import { faAward } from '@fortawesome/pro-solid-svg-icons/faAward'
import { faAlarmClock } from '@fortawesome/pro-solid-svg-icons/faAlarmClock'
import { faAddressCard } from '@fortawesome/pro-solid-svg-icons/faAddressCard'
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard'
import { faIdCardAlt } from '@fortawesome/pro-solid-svg-icons/faIdCardAlt'
import { faTruck } from '@fortawesome/pro-solid-svg-icons/faTruck'
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons/faShoppingCart'
import { faServer } from '@fortawesome/pro-solid-svg-icons/faServer'
import { faEuroSign } from '@fortawesome/pro-solid-svg-icons/faEuroSign'

library.add(
  faFileInvoice, faFileInvoiceDollar, faFileAlt, faFileExclamation, faFile, faFileUser, faFileSignature, faFileContract,
  faUser, faUserCircle, faTools, faThumbsUp, faThumbsDown, faStar, faStarExclamation, faInfoCircle, faExclamationTriangle,
  faExclamationCircle, faExclamationSquare, faExclamation, faCheck, faCheckCircle, faCheckDouble, faCheckSquare, faCalendarAlt,
  faCalendar, faCalculator, faBadgeCheck, faAward, faAlarmClock, faAddressCard, faCreditCard, faIdCardAlt, faTruck,
  faShoppingCart, faServer, faEuroSign
)


const icons = [
  ['fas', 'file-invoice'],
  ['fas', 'file-invoice-dollar'],
  ['fas', 'file-alt'],
  ['fas', 'file-exclamation'],
  ['fas', 'file'],
  ['fas', 'file-user'],
  ['fas', 'file-signature'],
  ['fas', 'file-contract'],
  ['fas', 'user'],
  ['fas', 'user-circle'],
  ['fas', 'tools'],
  ['fas', 'thumbs-up'],
  ['fas', 'thumbs-down'],
  ['fas', 'star'],
  ['fas', 'star-exclamation'],
  ['fas', 'info-circle'],
  ['fas', 'exclamation-triangle'],
  ['fas', 'exclamation-square'],
  ['fas', 'exclamation-circle'],
  ['fas', 'exclamation'],
  ['fas', 'check'],
  ['fas', 'check-circle'],
  ['fas', 'check-double'],
  ['fas', 'check-square'],
  ['fas', 'calendar-alt'],
  ['fas', 'calendar'],
  ['fas', 'calculator'],
  ['fas', 'badge-check'],
  ['fas', 'award'],
  ['fas', 'alarm-clock'],
  ['fas', 'credit-card'],
  ['fas', 'address-card'],
  ['fas', 'id-card-alt'],
  ['fas', 'truck'],
  ['fas', 'shopping-cart'],
  ['fas', 'server'],
  ['fas', 'euro-sign']
]

export default icons
